<template>
  <div class="header-component">
    <van-nav-bar
      fixed
      left-text="返回"
      left-arrow
      @click-left="goBack"
      @click-right="goHome">
        <van-icon name="wap-home" slot="right" />
    </van-nav-bar>
  </div>
</template>
<script>
import { NavBar, Icon } from 'vant';

export default {
  name: 'xg-header',
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
  },
  data() {
    return {
      specialPath: [
        '/recharge/index',
        '/vip/index',
      ],
    };
  },
  computed: {
    isWechat() {
      return this.$tools.isWechat();
    },
    isAPP() {
      return navigator.userAgent.indexOf('Html5Plus') > -1;
    },
    hideHeader() {
      return this.$tools.judgeClient() === 'ios'
        && this.isAPP
        && !this.$route.meta.showHeaderInApp;
    },
    code() {
      return this.$tools.getUrlParam('code');
    },
  },
  methods: {
    goBack() {
      if (this.code && this.specialPath.includes(this.$route.path)) {
        window.location.href = `${window.location.origin}/#/ucenter`;
      } else {
        this.$router.go(-1);
      }
    },
    goHome() {
      if (this.code && this.specialPath.includes(this.$route.path)) {
        window.location.href = window.location.origin;
      } else {
        this.$router.push({
          name: 'home.index',
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
  .header-component {
    height: 44px;
    .van-icon {
      font-size: 22px;
    }
  }
</style>
